export default __webpack_public_path__ + "static/media/cerebrisans-medium.283bb930.eot";